var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnInit } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { DATE_FORMAT } from '../utils/dateUtils';
import * as uuid from 'uuid';
var DateRangePickerComponent = /** @class */ (function () {
    function DateRangePickerComponent(configService, translate, languageService) {
        this.configService = configService;
        this.translate = translate;
        this.languageService = languageService;
        this.format = 'YYYY-MM-DD HH:mm:ss';
        this.formatOutput = 'YYYY-MM-DDTHH:mm:ss';
        this.dateRange = {};
        this.inputId = uuid.v4();
        this.timePicker = true;
        this.startDate = new Date();
        this.endDate = new Date();
        this.maxDate = new Date();
        this.selected = new EventEmitter();
    }
    DateRangePickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configureDateFormat();
        this.updateTranslations();
        this.languageService.onLanguageChange.subscribe(function () {
            _this.updateTranslations();
        });
    };
    Object.defineProperty(DateRangePickerComponent.prototype, "pickerOptions", {
        get: function () {
            return __assign({}, this.options, { minDate: this.minDate || undefined, startDate: this.startDate || undefined, endDate: this.endDate || undefined, maxDate: this.maxDate || undefined, opens: this.opens || undefined });
        },
        enumerable: true,
        configurable: true
    });
    DateRangePickerComponent.prototype.updateTranslations = function () {
        var currentLang = this.translate.currentLang || 'en';
        this.translations = {
            translatedMonths: this.configService.getValue('months')[currentLang],
            translatedRanges: this.configService.getValue('dateRanges')[currentLang],
        };
        this.options = {
            timePicker: this.timePicker,
            applyClass: 'primary',
            cancelClass: 'warn',
            opens: 'left',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            locale: {
                format: this.format,
                monthNames: this.translations.translatedMonths,
            },
            ranges: this.translations.translatedRanges,
            startDate: this.startDate,
            endDate: this.endDate,
            maxDate: this.maxDate,
            minDate: this.minDate || undefined,
        };
    };
    DateRangePickerComponent.prototype.configureDateFormat = function () {
        if (!this.timePicker) {
            this.format = DATE_FORMAT;
            this.formatOutput = DATE_FORMAT;
        }
    };
    DateRangePickerComponent.prototype.selectedDate = function (value) {
        this.dateRange.dateFrom = value.start.format(this.formatOutput);
        this.dateRange.dateTo = value.end.format(this.formatOutput);
        this.selected.next(this.dateRange);
    };
    return DateRangePickerComponent;
}());
export { DateRangePickerComponent };
